<template>
  <div class="_cont">
    <h3 class="formHead">{{formTitle}}</h3>
    <van-form @submit="onSubmit"
              ref="formName">
      <van-field v-model="form.cert_name"
                 name="Your name"
                 label="Your name"
                 placeholder="Your name"
                 :rules="[{ required: true, message: 'Please input your name' }]" />
      <van-field v-model="form.phone"
                 name="Phone"
                 label="Phone"
                 placeholder="Phone"
                 :rules="[{ required: true, message: 'Please input your phone number' }]" />
      <van-field v-model="form.email"
                 name="Email"
                 label="Email"
                 placeholder="Email"
                 :rules="[{ required: true, message: 'Please input your Email' }]" />
      <div style="margin: 16px;">
        <van-button round
                    block
                    type="info"
                    native-type="submit">Submit</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import axiosApi from "../api/api.js";
import { Toast } from 'vant';
export default ({
  name: 'Form-bm',
  props: {
    formTitle: {
      type: String,
      default: ''
    },
    typeId: {
      type: Number,
    },
  },
  data () {
    return {
      form: {
        cert_name: '',
        phone: '',
        email: '',
      },
    }
  },
  methods: {
    onSubmit () {
      axiosApi('message', {
        form_type: this.typeId,
        conent: this.formTitle,
        ...this.form
      }, 'post').then(res => {
        if (res.data.status) {
          Toast.success('success')
          this.form = {
            cert_name: '',
            phone: '',
            content: '',
          }
          this.$emit('hideForm');
          this.$refs.formName.resetValidation();
        } else {
          Toast.fail('error')
        }
      })
    },
    clearForm () {
      this.$refs.formName.resetValidation();
      this.form = {
        cert_name: '',
        phone: '',
        content: '',
      }
    }
  },
})
</script>

<style lang="scss" scoped>
.formHead {
  text-align: center;
  font-size: 36px;
  margin-bottom: 20px;
}
._cont {
  padding: 20px 0;
}
</style>